// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPortfolioFundAssetDto
 */
export interface IPortfolioFundAssetDto {
    /**
     * 
     * @type {number}
     * @memberof IPortfolioFundAssetDto
     */
    instrument_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPortfolioFundAssetDto
     */
    election?: number;
    /**
     * 
     * @type {number}
     * @memberof IPortfolioFundAssetDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPortfolioFundAssetDto
     */
    fund_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPortfolioFundAssetDto
     */
    research_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IPortfolioFundAssetDto
     */
    image_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IPortfolioFundAssetDto
     */
    type?: IPortfolioFundAssetDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPortfolioFundAssetDto
     */
    instrument_status?: IPortfolioFundAssetDtoInstrumentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IPortfolioFundAssetDto
     */
    instrument_category_type?: IPortfolioFundAssetDtoInstrumentCategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPortfolioFundAssetDto
     */
    symbol?: string;
}

/**
* @export
* @enum {string}
*/
export enum IPortfolioFundAssetDtoTypeEnum {
    EQUITY = 'EQUITY',
    ETF = 'ETF',
    ADR = 'ADR',
    ETN = 'ETN',
    ALTERNATIVE_ASSET = 'ALTERNATIVE_ASSET',
    CRYPTO = 'CRYPTO',
    INTEREST_RATE = 'INTEREST_RATE',
    CYBER_SECURITY = 'CYBER_SECURITY',
    METALS = 'METALS',
    MUTUAL_FUND = 'MUTUAL_FUND'
}
/**
* @export
* @enum {string}
*/
export enum IPortfolioFundAssetDtoInstrumentStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    CLOSE_ONLY = 'CLOSE_ONLY',
    HALTED = 'HALTED'
}
/**
* @export
* @enum {string}
*/
export enum IPortfolioFundAssetDtoInstrumentCategoryTypeEnum {
    SHORT_TERM_BOND = 'SHORT_TERM_BOND',
    INTERMEDIATE_CORE_BOND = 'INTERMEDIATE_CORE_BOND',
    INTERMEDIATE_CORE_PLUS_BOND = 'INTERMEDIATE_CORE_PLUS_BOND',
    INFLATION_PROTECTED_BOD = 'INFLATION_PROTECTED_BOD',
    GLOBAL_BOND = 'GLOBAL_BOND',
    HIGH_YIELD_BOND = 'HIGH_YIELD_BOND',
    LARGE_VALUE = 'LARGE_VALUE',
    LARGE_BLEND = 'LARGE_BLEND',
    LARGE_GROWTH = 'LARGE_GROWTH',
    MID_CAP_VALUE = 'MID_CAP_VALUE',
    MID_CAP_BLEND = 'MID_CAP_BLEND',
    MID_CAP_GROWTH = 'MID_CAP_GROWTH',
    SMALL_VALUE = 'SMALL_VALUE',
    SMALL_BLEND = 'SMALL_BLEND',
    SMALL_GROWTH = 'SMALL_GROWTH',
    REAL_ESTATE = 'REAL_ESTATE',
    FOREIGN_LARGE_BLEND = 'FOREIGN_LARGE_BLEND',
    FOREIGN_SMALL_MID_BLEND = 'FOREIGN_SMALL_MID_BLEND',
    DIVERSIFIED_EMERGING_MKTS = 'DIVERSIFIED_EMERGING_MKTS',
    MONEY_MARKET_FUND = 'MONEY_MARKET_FUND'
}


/**
 * Check if a given object implements the IPortfolioFundAssetDto interface.
 */
export function instanceOfIPortfolioFundAssetDto(value: object): value is IPortfolioFundAssetDto {
    return true;
}

export function IPortfolioFundAssetDtoFromJSON(json: any): IPortfolioFundAssetDto {
    return IPortfolioFundAssetDtoFromJSONTyped(json, false);
}

export function IPortfolioFundAssetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPortfolioFundAssetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instrument_id': json['instrument_id'] == null ? undefined : json['instrument_id'],
        'election': json['election'] == null ? undefined : json['election'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'fund_name': json['fund_name'] == null ? undefined : json['fund_name'],
        'research_url': json['research_url'] == null ? undefined : json['research_url'],
        'image_url': json['image_url'] == null ? undefined : json['image_url'],
        'type': json['type'] == null ? undefined : json['type'],
        'instrument_status': json['instrument_status'] == null ? undefined : json['instrument_status'],
        'instrument_category_type': json['instrument_category_type'] == null ? undefined : json['instrument_category_type'],
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
    };
}

export function IPortfolioFundAssetDtoToJSON(json: any): IPortfolioFundAssetDto {
    return IPortfolioFundAssetDtoToJSONTyped(json, false);
}

export function IPortfolioFundAssetDtoToJSONTyped(value?: IPortfolioFundAssetDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instrument_id': value['instrument_id'],
        'election': value['election'],
        'amount': value['amount'],
        'fund_name': value['fund_name'],
        'research_url': value['research_url'],
        'image_url': value['image_url'],
        'type': value['type'],
        'instrument_status': value['instrument_status'],
        'instrument_category_type': value['instrument_category_type'],
        'symbol': value['symbol'],
    };
}

